export const SLA_REPORT_LIST_PAGE_TITLE = "SLA 월별보고서";
export const SLA_REPORT_LIST_PAGE_INDICATOR = "평가관리/보고서 > SLA 관리 > SLA 월별보고서";

export function formatSlaReportHeroTitle(sla) {
    if (!sla || typeof sla !== "object") {
        return "SLA 보고서";
    }

    const dateValue = sla.createdAt || sla.updatedAt;
    if (dateValue) {
        const date = new Date(dateValue);
        if (!Number.isNaN(date.getTime())) {
            return `${date.getMonth() + 1}월 ${date.getDate()}일 SLA 보고서`;
        }
    }

    if (sla.month) {
        const normalized = String(sla.month);
        const match = normalized.match(/^(\d{4})-(\d{1,2})$/);
        if (match) {
            const month = parseInt(match[2], 10);
            const year = parseInt(match[1], 10);
            const day = new Date(year, month, 0).getDate();
            return `${month}월 ${day}일 SLA 보고서`;
        }

        const monthOnly = normalized.match(/^(\d{1,2})$/);
        if (monthOnly) {
            return `${parseInt(monthOnly[1], 10)}월 SLA 보고서`;
        }
    }

    return "SLA 보고서";
}

export function formatSlaReportMonthLabel(month) {
    if (!month) {
        return "";
    }

    const normalized = String(month);
    const match = normalized.match(/^(\d{4})-(\d{1,2})$/);
    if (match) {
        return `${parseInt(match[2], 10)}`;
    }

    return normalized;
}
